import { GET_CHAT_REQUESTED, GET_CHAT_SUCCESS, GET_CHAT_FAILURE } from './chat.constants'

import { GET_CONTACT_REQUESTED } from '../MediaPlayer/mediaPlayer.constants'

const initialState = {
  text: {
    loading: true,
    error: false,
    data: {},
  },
}

// Set the text of the chat. we need to reset when a new contact is selected
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_REQUESTED:
    case GET_CHAT_REQUESTED:
      return { ...initialState }
    case GET_CHAT_SUCCESS:
      return {
        text: {
          loading: false,
          error: false,
          data: action.data,
        },
      }
    case GET_CHAT_FAILURE:
      return {
        text: {
          loading: false,
          error: action.error,
          data: {},
        },
      }
    default:
      return state
  }
}
